"use client";
import { jsx as l } from "react/jsx-runtime";
import { memo as e } from "react";
import a from "../components/Icon/SvgIcon.js";
const r = (o) => /* @__PURE__ */ l(
  a,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m5.402 12.945.45.101c.61.139 1.134.21 1.56.21h2.082l-1.122 7.006a.44.44 0 0 0 .102.363.452.452 0 0 0 .707-.029l5.283-7.34h.31c.931-.005 1.568-.002 2.033 0 .866.002 1.104.003 1.508-.046 1.361-.177 2.096-.764 2.096-1.228 0-.462-.736-1.05-2.096-1.225-.402-.05-.637-.051-1.509-.046-.466.002-1.104.005-2.032 0l-.31-.002L9.18 3.372a.45.45 0 0 0-.808.333l1.122 7.007H7.411c-.425 0-.949.07-1.56.21l-.449.1-1.425-2.609a.404.404 0 0 0-.752.265l.44 2.476-.01 1.77-.43 2.364a.403.403 0 0 0 .4.477.4.4 0 0 0 .352-.21zM8.815 22a1.664 1.664 0 0 1-1.645-1.93l.895-5.597h-.654c-.4 0-.863-.049-1.377-.145l-.987 1.81a1.622 1.622 0 0 1-3.02-1.068l.42-2.312v-1.55l-.42-2.312a1.62 1.62 0 0 1 .351-1.33 1.62 1.62 0 0 1 1.245-.583 1.62 1.62 0 0 1 1.424.847l.987 1.807a7.6 7.6 0 0 1 1.377-.145h.654L7.17 3.895a1.66 1.66 0 0 1 .377-1.344c.664-.78 2.026-.722 2.622.108l4.921 6.835c.76.002 1.302 0 1.711-.002.886-.005 1.186-.006 1.668.056 1.92.248 3.16 1.204 3.16 2.435s-1.24 2.188-3.157 2.435c-.486.062-.787.062-1.67.056-.409-.002-.95-.004-1.712-.002l-4.92 6.835A1.67 1.67 0 0 1 8.814 22",
        clipRule: "evenodd"
      }
    )
  }
), h = e(r);
export {
  h as Travel,
  h as default
};
